export default __webpack_public_path__ + "static/media/passe_partout1.dda3aed0.JPG";